import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/crypto-mining-calculator',
  component: () => import('../../routes/CryptoMiningCalculator.svelte'),
  card: {
    id: 'crypto-mining-calculator',
    title: 'Crypto Mining Profitability',
    description:
      'Calculate Bitcoin mining profitability from hashrate, electricity cost, block reward, and BTC price. Includes break-even analysis, hardware ROI, and monthly breakdown.',
    icon: 'memory',
    iconBgClass: 'bg-yellow-50',
    iconTextClass: 'text-yellow-600',
    href: '/crypto-mining-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Crypto Mining Profitability Calculator – Bitcoin Mining ROI',
    description:
      'Free Bitcoin mining profitability calculator. Estimate daily and monthly revenue, electricity costs, pool fees, and break-even electricity price for ASIC miners. Includes hardware ROI and profitability classification.',
  },
};

export default meta;
